import { type FC } from 'react';

type Share24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Share24: FC<Share24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path d="M6 22C5.45 22 4.979 21.804 4.588 21.413C4.196 21.021 4 20.55 4 20V10C4 9.45 4.196 8.979 4.588 8.588C4.979 8.196 5.45 8 6 8H9V10H6V20H18V10H15V8H18C18.55 8 19.021 8.196 19.413 8.588C19.804 8.979 20 9.45 20 10V20C20 20.55 19.804 21.021 19.413 21.413C19.021 21.804 18.55 22 18 22H6ZM11 16V4.825L9.4 6.425L8 5L12 1L16 5L14.6 6.425L13 4.825V16H11Z" />
        </svg>
    );
};

export default Share24;
